var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [_vm._v(" Introdução ")]),
      _c(
        "p",
        { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
        [
          _vm._v(
            " Olá! Na aba Monitoramento do Diagnóstico Técnico você encontra o filtro: Unidade(s) posicionado do lado esquerdo. Neste filtro você poderá selecionar a(s) unidade(s) que pretende monitorar, e será possível analisar, por meio de gráficos e tabelas, a participação dos servidores no diagnóstico técnico da(s) unidade(s) selecionadas. "
          ),
        ]
      ),
    ]),
    _c("div", [
      _c("h2", [_vm._v(" Gráficos e Tabelas ")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " O velocímetro apresenta o percentual de servidores que concluíram todas as avaliações técnicas disponíveis. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " A tabela apresenta a lista dos servidores da(s) unidade(s) selecionada(s), a categoria (gestor ou servidor) e quais avaliações já realizaram. "
            ),
            _c("br"),
            _vm._v(
              " Em cada coluna da tabela é possível utilizar os recursos de ordenação, de forma crescente ou decrescente, podendo ainda realizar pesquisa por qualquer termo da tabela. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na sequência são apresentados os servidores dispensados de participar do diagnóstico técnico. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("div", { staticClass: "mx-2 pa-2 justify-center" }, [
        _c(
          "p",
          {
            staticClass: "text-start font-weight-medium info--text text-lg-h6",
          },
          [
            _vm._v(
              " Recomenda-se visitar essa aba para acompanhar a evolução da participação dos servidores no período do Diagnóstico Técnico. "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }